export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_020ce7d5-bc4d-4e39-872a-d84573b11021/artifacts/6liw0csq_AYS%20Logo.jpg";

export const CONTACT = {
  phone: "(705) 358-9544",
  phoneHref: "tel:+17053589544",
  email: "dlyle1984@gmail.com",
  emailHref: "mailto:dlyle1984@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=61563090242154",
  region: "Almaguin Highlands & Muskoka, ON",
};

export const PHOTOS = {
  firepit:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/thfhny04_front%20and%20backyard%20transformation%20after.webp",
  armourWall:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/z4373hm5_front%20and%20backyard%20transformation%20before.jpg",
  flagstone:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/abpjzrnc_Front%20Entrance%20Frest%20Start.webp",
  frontPathBefore:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/tfc67ryi_Front%20Entrance%20Frest%20Start%201.webp",
  frontBefore:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/8iqzeqra_Front%20Entrance%20Frest%20Start_before.png",
  frontAfter:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/q1ik8p1y_Front%20Entrance%20Frest%20Start_after.png",
  gravelPad:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/swz0ye1z_gravel%20driveway%201.webp",
  gravelDrive:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/194zmat4_gravel%20driveway%202.jpg",
  forestTrail:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/70a74mjv_gravel%20driveway%203.webp",
  waterfrontCleared:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/c0a5eeb2512589d1_Waterfront%20propety%202.webp",
  recognition:
    "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/be8acb172a12c060_Magnetawan%20Horticultural%20Society%20sitting%20area%2C%20company%20recognition.jpg",
};

export const IMAGES = {
  hero: PHOTOS.waterfrontCleared,
};

export const SERVICES = [
  {
    id: "land-clearing",
    name: "Land Clearing & Brush Removal",
    short: "Land Clearing",
    desc: "Tree removal, forestry mulching, and lot clearing for new cottage builds, driveways, and waterfront views.",
  },
  {
    id: "excavation",
    name: "Excavation & Site Grading",
    short: "Excavation & Grading",
    desc: "Precision foundation digging, laser site leveling, resloping, ditching, and drainage solutions built for Canadian Shield rock.",
  },
  {
    id: "hardscaping",
    name: "Hardscaping & Retaining Walls",
    short: "Retaining Walls",
    desc: "Granite armour stone, engineered retaining walls, flagstone patios, and natural stone steps.",
  },
  {
    id: "landscaping",
    name: "Landscaping & Lawn Design",
    short: "Landscaping",
    desc: "Custom terrain shaping, garden beds, topsoil installation, and complete cottage yard transformations.",
  },
  {
    id: "hydroseeding",
    name: "Hydroseeding & Lawn Turf",
    short: "Hydroseeding",
    desc: "High-efficiency hydroseed application for fast, dense, erosion-resistant lawn establishment.",
  },
  {
    id: "aggregate",
    name: "Aggregate & Topsoil Delivery",
    short: "Aggregate Delivery",
    desc: "Direct delivery of crushed granite, gravel, screening, sand, and triple-mix soil to your property.",
  },
  {
    id: "maintenance",
    name: "Property Maintenance & Tree Care",
    short: "Property Maintenance",
    desc: "Seasonal property cleanup, ongoing landscaping maintenance, hazard tree trimming, and brush management.",
  },
  {
    id: "driveway",
    name: "Driveway Landscaping & Repair",
    short: "Driveways",
    desc: "Gravel driveway building, regrading, culvert installation, and edging built for cottage country freeze-thaw cycles.",
  },
  {
    id: "trails",
    name: "Trail Cutting & Clearing",
    short: "Trail Cutting",
    desc: "ATV, walking, and access trails cut and cleared through your bush — from hunt camps to waterfront paths.",
  },
  {
    id: "forestry-mulching",
    name: "Forestry Mulching",
    short: "Forestry Mulching",
    desc: "Eco-friendly brush and small tree mulching that clears land without burning or hauling debris away.",
  },
];

export const TESTIMONIALS = [
  {
    author: "Adam Black",
    location: "Facebook Review",
    rating: 5,
    text: "I hired Almaguin Yard Solutions to clean up some brush piles I had with his forestry mulcher. I was very impressed with how efficient it was compared to a traditional woodchipper. I would highly recommend hiring Almaguin Yard Solutions Inc.",
  },
  {
    author: "ILB Blitz",
    location: "Facebook Review",
    rating: 5,
    text: "Dan was awesome to work with. He gave me a quote that was reasonable and after everything was completed he actually came in $2k under budget. In this day and age what contractor gives a quote and honors it, let alone completes under budget? Dan does! Great work with the mulcher and excavator!",
  },
  {
    author: "Sean Whyte",
    location: "Facebook Review",
    rating: 5,
    text: "Dan is a genuine and honest individual to deal with. Does a great job of clearing up your land with minimal impact to the ground beneath.",
  },
  {
    author: "Megan Yates",
    location: "Facebook Review",
    rating: 5,
    text: "I was super impressed with the work that was done in my yard! Dan was helpful, professional and an overall nice guy! He also helped me with a few extra projects I needed which was so appreciated. He responded within a quick timeline, was easy to communicate with, and most importantly I was more than happy with his work! Highly recommend!",
  },
  {
    author: "Dave",
    location: "Facebook Review",
    rating: 5,
    text: "Had trees and stumps removed, landscaping work done for drainage, aggregate delivered. Dan did a great job... very happy with the results!",
  },
  {
    author: "JD Robinson",
    location: "Facebook Review",
    rating: 5,
    text: "I had a set of deck stairs that was falling apart that Almaguin Yard Solutions replaced. I had many quotes for the work, but all of them were insanely high. Almaguin Yard Solutions charged a fair price and completed the job quickly. Good quality work and friendly service. Highly recommend them for any landscaping needs you have.",
  },
  {
    author: "Daniel Foy",
    location: "Facebook Review",
    rating: 5,
    text: "Had some mulch and top soil delivered and spread out. Dan was very courteous and went above and beyond.",
  },
  {
    author: "Bob Freeman",
    location: "Facebook Review",
    rating: 5,
    text: "Dan is the best... easy to work with and goes above and beyond to get the perfect job.",
  },
];

export const GALLERY = [
  { src: PHOTOS.firepit, category: "Patios & Hardscape", title: "Backyard Fire Pit Pad", details: "Armour stone ring & gravel fire pit pad" },
  { src: PHOTOS.armourWall, category: "Retaining Walls", title: "Armour Stone Wall", details: "Armour stone wall with full yard regrade" },
  { src: PHOTOS.flagstone, category: "Patios & Hardscape", title: "Flagstone Walkway", details: "Flagstone set in gravel, fresh screened topsoil" },
  { src: PHOTOS.gravelPad, category: "Driveways & Trails", title: "Gravel Pad & Boulders", details: "Graded gravel pad with armour stone boulders" },
  { src: PHOTOS.gravelDrive, category: "Driveways & Trails", title: "Gravel Driveway", details: "Fresh gravel resurface with crown & clean edges" },
  { src: PHOTOS.forestTrail, category: "Driveways & Trails", title: "Bush Trail", details: "Trail cut & graveled through standing bush" },
  { src: PHOTOS.frontAfter, category: "Patios & Hardscape", title: "Front Entrance Makeover", details: "Flagstone walkway & fresh topsoil" },
];

export const GALLERY_FILTERS = ["All Work", "Retaining Walls", "Patios & Hardscape", "Driveways & Trails"];

export const SERVICE_AREAS = [
  "Sundridge",
  "South River",
  "Burk's Falls",
  "Huntsville",
  "Bracebridge",
  "Parry Sound",
  "Almaguin Highlands",
];

export const PROPERTY_TYPES = ["Cottage / Waterfront", "Residential", "Commercial", "Bare Land"];

export const BA_PAIRS = [
  {
    title: "Worn Front Yard to Flagstone & Fresh Topsoil",
    subtitle: "Full Front Yard Makeover",
    hideLabels: true,
    before: PHOTOS.frontBefore,
    beforeAlt: "Front yard with worn concrete path and patchy lawn before makeover",
    after: PHOTOS.frontAfter,
    afterAlt: "Front yard with new flagstone walkway and freshly graded topsoil after makeover",
  },
  {
    title: "Overgrown Bush to Cleared Trail",
    subtitle: "Forestry Mulching & Land Clearing",
    before:
      "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/feb3b93975a41d65_overgrown%20bush_before.webp",
    beforeAlt: "Dense overgrown bush with tangled saplings before forestry mulching",
    after:
      "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/cee77b4226a0365a_overgrown%20bush_afer.webp",
    afterAlt: "Cleared mulched trail through opened-up bush after forestry mulching",
  },
  {
    title: "Working Waterfront to Cleared Lake View",
    subtitle: "Waterfront Property Clearing",
    before:
      "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/0b64e087ce926d18_Waterfront%20propety%201.webp",
    beforeAlt: "Freshly cleared and mulched waterfront slope open to the dock and lake view",
    after:
      "https://customer-assets-jai6qajn.emergentagent.net/job_outdoor-spaces-23/artifacts/c0a5eeb2512589d1_Waterfront%20propety%202.webp",
    afterAlt: "Excavator and skid steer clearing a wooded waterfront lot",
  },
];
